import { useState } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  FormControl,
  InputGroup,
  Row,
} from "react-bootstrap";
import { FiltrosFacturas } from "./FiltrosFacturas";
import "./facturas.css";
import "../ui/filtros/selects.css";
import { useTranslation } from "react-i18next";
import { LoaderPetroprix } from "../ui/LoaderPetroprix";
import { TablaFacturas } from "./TablaFacturas";
import { useSelector } from "react-redux";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
import { useLocalizedRoutes } from "../../hooks/useLocalizedRoutes";

const URL_GET_FACTURAS = "facturas";

export const FacturasScreen = () => {
  const { t } = useTranslation();
  const [facturas, setFacturas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [resultadosBusqueda, setResultadosBusqueda] = useState(facturas);
  const [terminoBusqueda, setTerminoBusqueda] = useState("");
  const [filtered, setFiltered] = useState(false);
  const { token, nombre, apellido } = useSelector((state) => state.auth);

  const navigate = useNavigate();
  const { getPath } = useLocalizedRoutes();

  const orderData = (asc, index) => () => {
    let data;
    if (!filtered) {
      data = [...facturas];
    } else {
      data = [...resultadosBusqueda];
    }

    switch (index) {
      case 0:
        index = "fecha";
        break;
      case 1:
        index = "periodo";
        break;
      case 2:
        index = "total";
        break;
      case 3:
        index = "num_factura";
        break;
      default:
        break;
    }

    if (asc) {
      data.sort((a, b) => {
        if (a[index] < b[index]) {
          return -1;
        }
        if (a[index] > b[index]) {
          return 1;
        }
        return 0;
      });
    } else {
      data.sort((a, b) => {
        if (a[index] > b[index]) {
          return -1;
        }
        if (a[index] < b[index]) {
          return 1;
        }
        return 0;
      });
    }
    filtered ? setResultadosBusqueda(data) : setFacturas(data);
  };

  const filtrar = (terminoBusqueda) => {
    let result = facturas.filter((elemento) => {
      if (
        format(new Date(elemento.fecha), "dd/MM/yyyy")
          .toString()
          .toLowerCase()
          .includes(terminoBusqueda.toLowerCase()) ||
        elemento.total
          .toString()
          .toLowerCase()
          .includes(terminoBusqueda.toLowerCase()) ||
        elemento.num_factura
          .toString()
          .toLowerCase()
          .includes(terminoBusqueda.toLowerCase())
      ) {
        return elemento;
      }
    });
    setResultadosBusqueda(result);
    setFiltered(true);
  };

  const handleNavigationDatosFacturacion = () => {
    navigate(getPath('billingData'));
  };

  return (
    <>
      <Container className="content-body mt-4 px-4">
        <Container>
          {/* <Row className={`page-header pb-4`}>
            <Col sm={12} lg={{ span: 5, order: 1 }}>
              <h1>{t("facturas.header.h1")}</h1>
            </Col>
            <Col sm={12} lg={{ span: 7, order: 3 }} className="text-end">
              <Button
                variant="primary"
                onClick={handleNavigationDatosFacturacion}
              >
                {t("facturas.header.btn-consultar-datos")}
              </Button>
            </Col>
          </Row> */}
          <Row className="filters-row">
            <Col sm={12} lg={5}>
              <Button
                variant="primary"
                onClick={handleNavigationDatosFacturacion}
              >
                {t("facturas.header.btn-consultar-datos")}
              </Button>
              {/* <Button variant="outline-primary">
                <DownloadIconNew
                  width="1rem"
                  height="1rem"
                  style={{ marginRight: "0.5rem" }}
                />
                {t("facturas.header.btn-descargar")}
              </Button> */}
            </Col>
            <Col sm={12} lg={4} className="filter-select-filters facturas">
              <FiltrosFacturas
                url={URL_GET_FACTURAS}
                token={token}
                facturas={facturas}
                setFacturas={setFacturas}
                loading={loading}
                setLoading={setLoading}
                setTerminoBusqueda={setTerminoBusqueda}
                setFiltered={setFiltered}
              />
            </Col>
            <Col sm={12} lg={3}>
              <Form
                className="search-facturas-form"
                onSubmit={(e) => {
                  e.preventDefault();
                }}
                autoComplete="off"
              >
                <InputGroup className="">
                  <InputGroup.Text>
                    <span className="material-icons-outlined">search</span>
                  </InputGroup.Text>
                  <FormControl
                    type="text"
                    placeholder={t("facturas.header.buscador")}
                    className="no-border-left"
                    id="buscadorFacturas"
                    name="searchText"
                    value={terminoBusqueda}
                    onChange={(e) => {
                      setTerminoBusqueda(e.target.value);
                      filtrar(e.target.value);
                    }}
                    autoComplete="off"
                  />
                </InputGroup>
              </Form>
            </Col>
          </Row>
        </Container>
        <Container className="mt-5 mb-3 py-1 bg-white radius-8">
          <Row className="content-section">
            {!loading ? (
              <>
                {facturas.length > 0 ? (
                  <>
                    <TablaFacturas
                      data={filtered ? resultadosBusqueda : facturas}
                      token={token}
                      orderData={orderData}
                    />
                    <Row>
                      <Col
                        className="d-none d-lg-block"
                        lg={{ span: 2, offset: 10 }}
                      ></Col>
                    </Row>
                  </>
                ) : (
                  <p className="text-center">
                    {t("facturas.form.table.no-results")}
                  </p>
                )}
              </>
            ) : (
              <LoaderPetroprix />
            )}
          </Row>
        </Container>
      </Container>
    </>
  );
};
